const initialState = {
  server: [],
  serverById: [],
  tableLoading: false,
  sidebarLoading: false,
  total: 0,
  modalDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  modalData: {
    emableModel: false,
    message: "",
    displayMsg: "",
    enableCancelButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
};

const OrchestratorServerReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "GET_ORCHESTRATOR_SERVER":
      return {
        ...state,
        server: payload || [],
      };
    case "GET_ORCHESTRATOR_SERVER_BY_ID":
      return {
        ...state,
        serverById: payload || [],
      };
    case "SAVE_ORCHESTRATOR_SERVER":
      return {
        ...state,
        server: [...state.server, payload],
        total: state.total + 1,
      };
    case "UPDATE_ORCHESTRATOR_SERVER":
      return {
        ...state,
        serverById: state.server.map((b) => {
          return b.id === payload.id ? payload : b;
        }),
      };
    case "OPEN_ORCHESTRATOR_SERVER_MODEL":
      return {
        ...state,
        modalData: action.value,
      };
    case "DELETE_ORCHESTRATOR_SERVER":
      return {
        ...state,
        server: state.server.filter(({ id }) => id !== payload),
      };
    case "OPEN_ORCHESTRATOR_SERVER_MODEL_DELETE":
      return {
        ...state,
        modalDeleteData: payload,
      };
    case "SET_ORCHESTRATOR_SERVER_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };
    case "SET_ORCHESTRATOR_SERVER_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };
    default:
      return state;
  }
};

export default OrchestratorServerReducer;
